import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { addLeadFields, addLeadTypes, getLeadFields, getLeadType, updateLeadFields, updateLeadType } from "./LeadRepository";
import { showToast } from "../../../../utils/toastUtils";

export const useLeadTypesData = ({
    params = {},
    enable = false,
}: { params?: Record<string, any>; enable?: boolean } = {}) => {
    return useQuery({
        queryKey: ["LEAD_TYPES", params],
        queryFn: () => getLeadType(params),
        enabled: enable,
        retry: false,
    });
};

export const useAddLeadTypes = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: addLeadTypes,
        onSuccess: (data) => {
            showToast.success("Lead Type Added Successfully!");
            queryClient.invalidateQueries({ queryKey: ["LEAD_TYPES"] });
            // <Loader />
        },
        onError: (error) => {
            showToast.warning("Failed to Add Lead Type!");
        },
    });
};

export const useUpdateLeadType = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: ({ id, body }: { id: number; body: any }) =>
            updateLeadType(id, body),
        onSuccess: (data) => {
            showToast.success("Update Lead Type Successfully!");
            queryClient.invalidateQueries({ queryKey: ["LEAD_TYPES"] });
        },
        onError: (error) => {
            showToast.warning("Failed to Update Lead Type!");
        },
    });
};

export const useLeadFieldsData = ({
    params = {},
    LeadTypeId = null,
    enable = false,
}: { LeadTypeId?: number|any; params?: Record<string, any>; enable?: boolean } = {}) => {
    return useQuery({
        queryKey: ["LEAD_FIELDS", params,LeadTypeId],
        queryFn: () => getLeadFields(LeadTypeId, params),
        enabled: enable,
        retry: false,
    });
};
export const useAddLeadFields = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: addLeadFields,
        onSuccess: (data) => {
            showToast.success("Lead Fields Added Successfully!");
            queryClient.invalidateQueries({ queryKey: ["LEAD_FIELDS"] });
            // <Loader />
        },
        onError: (error) => {
            showToast.warning("Failed to Add  Lead Fields!");
        },
    });
};
export const useUpdateLeadFields = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: ({ id, body }: { id: number; body: any }) =>
            updateLeadFields(id, body),
        onSuccess: (data) => {
            showToast.success("Update Lead Field Successfully!");
            queryClient.invalidateQueries({ queryKey: ["LEAD_FIELDS"] });
        },
        onError: (error) => {
            showToast.warning("Failed to Update Lead Field!");
        },
    });
};